import "./App.css";
import { BrowserRouter } from "react-router-dom";
import Router from "./Routes/router";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import actions from "./redux/Otp/actions"; // Import action for refresh token
import config from "./Services/apiEndPoints";
import { decryptData } from "./redux/encryptiondecryption"; // Import decrypt utility
import { useCheckTokenExpiry } from "./redux/checkTokenExpiry";
function App() {
  const dispatch = useDispatch();

  // Get the encrypted OTP data from localStorage and decrypt it
  const { checkTokenExpiry } = useCheckTokenExpiry();

  useEffect(() => {
    // Immediate check on app load
    checkTokenExpiry();

    // Set interval to recheck token expiry every 1 minute
    const interval = setInterval(checkTokenExpiry, 60000);

    // Cleanup the interval on unmount
    return () => clearInterval(interval);
  }, [checkTokenExpiry]);

  // Listen for localStorage changes
  useEffect(() => {
    const handleStorageChange = () => {
      checkTokenExpiry();
    };

    // Attach event listener for 'storage' event
    window.addEventListener("storage", handleStorageChange);

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [checkTokenExpiry]);

  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  );
}

export default App;
